module.exports = __webpack_public_path__ + "img/team-lissi-rob@2x.53731ecd.jpg";